import { isLegacyConnected } from '@/platform/utils/legacy-connector';
import { reactive, computed } from 'vue-demi';

// proxy alerts to legacy flashes when available ??
const legacyStore = window?.parent?.app?.hybrid?.store;
const maxAlerts = 3;

const alertState = reactive({
  alerts: [],
});

export default function useAlertManager() {
  function addLegacyAlert({ type, title, message, options }) {
    legacyStore.dispatch(`notifications/flashes/${type}`, { title, msg: message, opts: options });
  }

  /**
   * Add an alert
   *
   * @param {string} type - type of alert.  accepts "info", "success", "warning", or "error"
   * @param {string} message - the alert message text
   * @param {string} title - the alert alert title
   * @param {string} options - option for legacy alerts
   * @param {object} action - optional object that describes the alert action
   * @param {string} action.text - action button text
   * @param {string} action.fn - function to executed when alert action is clicked
   * @param {boolean} shouldUseLegacyAlerts - should use Hybrid alert
   * @param {boolean} isPersistent - should alert automatically be removed after duration has expired
   * @param {boolean} dismissible - should alert show close icon (maps to vuetify v-alert prop)
   * @param duration - time in milliseconds alert remains on screen before being automatically removed. timer is cleared when user's pointer enters the alert. Timer begins again when they're pointer leaves the alert.
   */
  function addAlert({
    type = 'success',
    message = '',
    title = '',
    options = {},
    action,
    shouldUseLegacyAlerts = true,
    isPersistent = false,
    dismissible = false,
    duration = 5000,
  }) {
    // proxy to the hybrid when connected, else use next-alerts
    if (isLegacyConnected() && shouldUseLegacyAlerts) {
      addLegacyAlert({ type, title: message, options });
      return;
    }

    const alertToAdd = {
      id: Date.now(),
      type,
      dense: false,
      dismissible,
      message,
      action,
      isPersistent,
      duration,
      title,
    };

    if (alertState.alerts.length === maxAlerts) {
      alertState.alerts.shift();
    }

    alertState.alerts.push(alertToAdd);
  }

  function removeAlert(alertIndex) {
    alertState.alerts.splice(alertIndex, 1);
  }

  const hasActivePersistentAlerts = computed(
    () => alertState.alerts.filter((alert) => alert.isPersistent).length > 0,
  );

  return {
    alertState,
    addAlert,
    removeAlert,
    hasActivePersistentAlerts,
  };
}
